<ng-container *transloco="let t">
	<vis-ods-three-section-drawer-layout-component>
		<ng-container content>
			<div class="flex flex-col">
				<div class="flex pb-s ml-m pt-m">
					<vis-ods-icon-component
						class="fill-body print:hidden hover:cursor-pointer"
						name="printer"
						width="24px"
						height="24px"
						(click)="openPrintDialog()"
					>
					</vis-ods-icon-component>
				</div>
			</div>
			<div *ngIf="$order() as product; appLoadingAnimation">
				<app-product-summary
					(editShippingAddressRequested)="routeToStoreSelector()"
					(editContactPersonRequested)="routeToContactPersonSelector()"
				></app-product-summary>
			</div>
		</ng-container>

		<div
			class="grid grid-cols-2 p-m bg-white gap-xs border-t border-separator justify-between print:hidden"
			footer
		>
			<button
				beyond-online-button
				[attr.data-testid]="'add-to-cart-button'"
				variant="secondary"
				class="justify-center flex-grow"
				[disabled]="$submitting()"
				(click)="addToCart()"
				[loading]="$isUserChangingCart() || $shipToStoresLoading() || $shipToContactsLoading()"
				[label]="
					$isEditMode()
						? t('productSummary.buttons.saveChanges')
						: t('productSummary.buttons.addToCart')
				"
			></button>
			<button
				class="justify-center flex-grow"
				beyond-online-button
				variant="primary"
				(click)="submitOrder()"
				[label]="t('productSummary.buttons.orderNow')"
				[loading]="$submitting() || $shipToStoresLoading() || $shipToContactsLoading()"
				[disabled]="
					!(rolesEnum.Buyer | userPermission) || $isBlockedFromOrdering() || $isUserChangingCart()
				"
			></button>
			@if ($isBlockedFromOrdering()) {
				<span class="text-body text-sm col-span-full justify-self-end">
					{{
						t('generalComponents.blockedFromOrderingToast.texts.message', {
							date: blockRemoveDate | dateTimeFormat,
						})
					}}
				</span>
			}
		</div>
	</vis-ods-three-section-drawer-layout-component>
</ng-container>
